import {createAction} from '@reduxjs/toolkit';

const PREFIX = 'items';

export const focusItem = createAction('FOCUS_ITEM');

export const focusItems = createAction(`${PREFIX}/focus`);
export const unfocusItems = createAction(`${PREFIX}/unfocus`);
export const unfocusAllItems = createAction(`${PREFIX}/unfocusAll`);
